<!-- Paging template -->
<template>
    <div class="loader-div"><img v-if="loading" src="../assets/tail-spin.svg" width="24" alt=""><p :class="{ 'm-0': noMargin }" v-if="!loading"> {{ message }} </p></div>
</template>

<script>

export default {
  name: 'LoadingSpinner',
  props: {
    noMargin: Boolean,
    loading: Boolean,
    message: String
  },
  data: function () {
    return {

    };
  },
  methods: {

  }
};
</script>

<style lang="scss">
    .loader-div {
        color: #999;
    }
</style>
